import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { ListadoAlmacenes } from "./components/ListadoAlmacenes";
import { loadConfiguracion } from "../../../../../../redux/modules/configuracion";
import "./styles/AlmacenesInventario.css";
import {
    getCategoriaAcopio,
    getNombreAcopio,
} from "../../../../../../utility/utils";

class AlmacenesInventario extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);

        const padrePTId = params.get("padrePT");
        const padrePTNombre = params.get("padrePTNombre");

        this.state = {
            inventarioId: props.match.params.id,
            filtroPadrePT: padrePTId
                ? {
                      id: Number(padrePTId),
                      nombre: padrePTNombre,
                  }
                : null,
        };
    }

    handleFiltroPadrePTChange = (padrePT) => {
        this.setState({
            filtroPadrePT: padrePT,
        });

        const params = new URLSearchParams(this.props.location.search);

        if (padrePT) {
            params.set("padrePT", padrePT.id);
            params.set("padrePTNombre", padrePT.nombre);
        } else {
            params.delete("padrePT");
            params.delete("padrePTNombre");
        }

        this.props.history.replace({
            search: params.toString(),
        });
    };

    regresar = () => {
        this.props.history.goBack();
    };

    verIngresosAlmacen = (almacenInventarioId) => {
        this.props.history.push(
            `/inventarios-almacen/ingresos-almacen/${almacenInventarioId}`,
        );
    };

    render() {
        const { user } = this.props;
        const categoriaAcopio = getCategoriaAcopio(user);
        const nombreAcopio = getNombreAcopio(user);

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="CIERRE DE INVENTARIO"
                    subtitulo=""
                    noBorder
                >
                    <ListadoAlmacenes
                        inventarioId={this.state.inventarioId}
                        regresar={this.regresar}
                        categoriaAcopio={categoriaAcopio}
                        nombreAcopio={nombreAcopio}
                        verIngresosAlmacen={this.verIngresosAlmacen}
                        filtroPadrePT={this.state.filtroPadrePT}
                        onFiltroPadrePTChange={this.handleFiltroPadrePTChange}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const loader = state.configuracion.loader;
    const user = state.login.me;

    return {
        configuraciones,
        loader,
        user,
    };
};

export default connect(mstp, { loadConfiguracion })(AlmacenesInventario);
